module.exports = file => () => import('@/components/' + file + '.vue')



// WEBPACK FOOTER //
// ./src/router/_import_production.js